import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const Input = ({
	className,
	type,
	...props
}: React.ComponentProps<'input'>) => {
	return (
		<input
			data-slot="input"
			type={type}
			className={cn(
				// Base styles
				'flex h-12 w-full rounded-md border px-3 py-2 text-base',
				// Light theme colors (using !important via arbitrary values to override any parent styles)
				'!bg-white !text-gray-900 !border-gray-300',
				'placeholder:!text-gray-500',
				// Focus state
				'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2',
				// Invalid state
				'aria-[invalid]:border-red-500',
				// Disabled state
				'disabled:cursor-not-allowed disabled:opacity-50',
				// Dark theme (only apply when html has dark class)
				'dark:!bg-gray-900 dark:!text-gray-100 dark:!border-gray-700',
				'dark:placeholder:!text-gray-400',
				'dark:focus-visible:ring-purple-400',
				// File input
				'file:border-0 file:bg-transparent file:text-base file:font-medium',
				// Responsive
				'md:text-sm md:file:text-sm',
				className,
			)}
			{...props}
		/>
	)
}

export { Input }
